//= require jquery/dist/jquery.js

function scrollControl(target, posDirection, posContainer,
    widthContainer, topBreakpoint, bottomBreakpoint, horizontalBreakPoint,
    topPos, stuckPos, bottomPos, widthMultiplyer, manageWidth, manageHorizontalPoz) {

    // set inital variables
    // viewport size
    var viewHeight = window.innerHeight;
    var viewWidth = window.innerWidth;
    var contentWidth = posContainer.width();
    var sizeWidth = widthContainer.width();

    //breakpoints
    var breakpointOne = topBreakpoint;
    var breakpointTwo = bottomBreakpoint;
    var wideBreakPoint = horizontalBreakPoint;

    // positioning
    var initTopOffset = topPos;
    var stickyTopOffset = stuckPos;
    var bottomScrollTop = bottomPos;

    // set inital position
    var manageHorizontalPoz = manageHorizontalPoz;
    var horizontalOffset = ((viewWidth - contentWidth) / 2);
    var howWide = (sizeWidth * widthMultiplyer);


    // console.log(": ");
    // console.log(": ");
    // console.log("scroll position: " + $(window).scrollTop());
    // console.log("break point 1: " + breakpointOne);
    // console.log("break point 2: " + breakpointTwo);


    // check position and set position
    if (viewWidth > wideBreakPoint) {

        // scrolls at top of page
        if (($(window).scrollTop() < breakpointOne)) {

            // console.log("break 1");

            target.removeClass("fixed");
            target.removeClass("bottom");
            target.addClass("absolute");

            target.css("top", initTopOffset + "px");
            // set width based on viewport etc if you want
            if (manageWidth) {
                target.css("width", howWide + "px");
            } else {
                target.css("width", ""); // need to put something in here to remove width clases when window is resized to mobile dimentions.
            }
            // set horizontal position based on viewport etc if you want
            if (manageHorizontalPoz) {
                target.css(posDirection, "0px");
            } else {
                target.css(posDirection, "");
            }
        }

        // fixed in place as we scroll down the page
        if ($(window).scrollTop() > breakpointOne) {

            // console.log("break 2");

            target.removeClass("absolute");
            target.removeClass("bottom");
            target.addClass("fixed");

            target.css("top", stickyTopOffset + "px");

            // set width based on viewport etc if you want
            if (manageWidth) {
                target.css("width", howWide + "px");
            } else {

            }
            // set horizontal position based on viewport etc if you want
            if (manageHorizontalPoz) {
                target.css(posDirection, horizontalOffset + "px");
            } else {
                target.css(posDirection, "");
            }
        }

        // scrolls at bottom of page
        if (($(window).scrollTop() > breakpointTwo) ) {

            // console.log("break 3");

            target.removeClass("absolute");
            target.removeClass("fixed");
            target.addClass("bottom");

            target.css("top", bottomScrollTop + "px");

            // set width based on viewport etc if you want
            if (manageWidth) {
                target.css("width", howWide + "px");
            } else {
                target.css("width", "");
            }
            // set horizontal position based on viewport etc if you want
            if (manageHorizontalPoz === true) {
                target.css(posDirection, "0px");
            } else {
                target.css(posDirection, "");
            }
        }

        // no right hand offset for things when screen has no cheek space
        if (viewWidth < contentWidth) {
            target.css(posDirection, "0px");
        }

    } else {
        target.removeClass("absolute");
        target.removeClass("fixed");
        target.removeClass("bottom");
        target.css("width", "")
        target.css(posDirection, "");
    }
};

function getAllTheScreenInfo() {

    // console.log("scroll position: " + ($(window).scrollTop()) );
    if ($(".order-summary").length) {
        // set inital variables

        var viewWidth = window.innerWidth;
        var viewHeight = window.innerHeight;
        var secondBox = $(".order-summary").outerHeight();
        var stickyBox = $(".totals");

        var stickyHeight = stickyBox.outerHeight();
        var endPoint = secondBox;

        var $stickyBit = $('.totals');
        var $positioningContainer = $('.order-summary');
        var posDirection = "right";
        var $sizingContainer = $('.order-summary');
        var widthMultiplyerValue = 1;  //between 0 and 1: defines the width of the sticky element as a percentage of $sizingContainer.
        var manageWidth = true;
        var manageHorizontalPoz = false;

        //breakpoints
        var wideBreakPoint = 768;
        // var scrollFor = $(".blog-hero-image").height();

          var stickPoint = 204;

        if ($("#user_type_prompt").is(":visible")) {
          stickPoint = $("#navbar").outerHeight() + $("#user_type_prompt").outerHeight() + 80;
        } else {
          stickPoint = $("#navbar").outerHeight() + 80;
        }




        var unstickPoint;
        var topSpacer = 234;
        var stuckSpacer = 170;
        var bottomSpacer = 1700;
        var form = $(".woocommerce-billing-fields__field-wrapper").offset();
        var formTop = form.top;
        // console.log("formTop: " + formTop);
        // console.log("viewWidth: " + viewWidth);




        //positioning numbers
        if (viewWidth > 1024) {
            unstickPoint = secondBox - (stickyHeight);
            unstickPoint = 100000000;
            topSpacer =  25;

            if ($("#user_type_prompt").is(":visible")) {
              stuckSpacer = $("#navbar").outerHeight() + $("#user_type_prompt").outerHeight() + 25;
            } else {
              stuckSpacer = $("#navbar").outerHeight()  + 25 ;
            }

            bottomSpacer = secondBox - (stickyHeight) + 25;


        }
        else if (viewWidth > 768 && viewWidth < 1025) {
            //
            // unstickPoint = secondBox - (stickyHeight);
            // topSpacer =  80;
            // stuckSpacer = 183;
            // bottomSpacer = secondBox - (stickyHeight);

            unstickPoint = secondBox - (stickyHeight);
            unstickPoint = 100000000;
            topSpacer =  25;

            if ($("#user_type_prompt").is(":visible")) {
              stuckSpacer = $("#navbar").outerHeight() + $("#user_type_prompt").outerHeight() + 25;
            } else {
              stuckSpacer = $("#navbar").outerHeight()  + 25 ;
            }

            bottomSpacer = secondBox - (stickyHeight) + 25;


        } else if (viewWidth < 797) {
            // unstickPoint = secondBox - (stickyHeight);
            // topSpacer =  70;
            // stuckSpacer = 270;
            // bottomSpacer = secondBox - (stickyHeight);

            unstickPoint = secondBox - (stickyHeight);
            unstickPoint = 100000000;
            topSpacer =  25;

            if ($("#user_type_prompt").is(":visible")) {
              stuckSpacer = $("#navbar").outerHeight() + $("#user_type_prompt").outerHeight() + 25;
            } else {
              stuckSpacer = $("#navbar").outerHeight()  + 25 ;
            }

            bottomSpacer = secondBox - (stickyHeight) + 25;

        }

        if (viewHeight > (stickyHeight + 117) ){  // 62
        scrollControl($stickyBit, posDirection, $positioningContainer, $sizingContainer,
            stickPoint, unstickPoint, wideBreakPoint, topSpacer, stuckSpacer, bottomSpacer,
            widthMultiplyerValue, manageWidth, manageHorizontalPoz);
        }

    }

    // subscriptions page
    if ($(".sticky-sign-up").length) {
        // set inital variables

        var viewWidth = window.innerWidth;
        var viewHeight = window.innerHeight;

        var secondBox = $(".subscribe-page").outerHeight();

        var stickyBox = $(".sticky-sign-up");

        var heightBit = $(".height-measure").outerHeight();
        var stickyHeight = stickyBox.innerHeight();

        var $stickyBit = $('.sticky-sign-up');
        var $positioningContainer = $('.subscribe-page');
        var posDirection = "right";
        var $sizingContainer = $('.subscribe-page');
        var $sizingContainerTwo = $sizingContainer.innerWidth();
        var widthMultiplyerValue = 0.25;  //between 0 and 1: defines the width of the sticky element as a percentage of $sizingContainer.
        var manageWidth = false;
        var manageHorizontalPoz = false;

        // console.log("2nd box: " + secondBox);
        //breakpoints
        var wideBreakPoint = 768;
        var stickPoint = 90;
        var unstickPoint;
        var topSpacer = 161;
        var stuckSpacer = 170;
        var bottomSpacer = 1700;
        var contentWrapper = $(".scroll-wrapper");
        var contentWrapperWidth = contentWrapper.innerWidth();
        var elemWidth;
        var elemPosition;
        // console.log("stickyHeight" + heightBit);
        //positioning numbers
        if (viewWidth > 1024) {
            topSpacer = 161; //0
            stuckSpacer = 191; //30
            bottomSpacer = (secondBox - (stickyHeight)) - 110;
            if (bottomSpacer <= 0 ){
                bottomSpacer = 162;
            }



            unstickPoint = secondBox - (stickyHeight) - 160;

            if (unstickPoint <= 0) {
                unstickPoint = 200;
            }
            // console.log("bottom spacer: " + bottomSpacer);

        } else if (viewWidth > 768 && viewWidth < 1025) {

            unstickPoint = secondBox - (stickyHeight) - 20;
            topSpacer = 0;
            stuckSpacer = 63;
            bottomSpacer = secondBox - (stickyHeight) - 110;

        } else if (viewWidth < 797) {
            unstickPoint = secondBox - (stickyHeight);
            topSpacer = 0;
            stuckSpacer = 150;
            bottomSpacer = secondBox - (stickyHeight);
        }
        if (viewHeight > (heightBit + 117)) {  // 62
            scrollControl($stickyBit, posDirection, $positioningContainer, $sizingContainer,
                stickPoint, unstickPoint, wideBreakPoint, topSpacer, stuckSpacer, bottomSpacer,
                widthMultiplyerValue, manageWidth, manageHorizontalPoz);

            //positioning numbers
            if (viewWidth > 1024) {

                elemWidth = $sizingContainerTwo / 4;
                elemPosition = (contentWrapperWidth - $sizingContainerTwo) / 2;
                $stickyBit.css("width", elemWidth + "px");
                $stickyBit.css("right", elemPosition + "px");

            } else if (viewWidth > 768 && viewWidth < 1025) {

                elemWidth = $sizingContainerTwo / 4;
                elemPosition = (contentWrapperWidth - $sizingContainerTwo) / 2;
                $stickyBit.css("width", elemWidth + "px");
                $stickyBit.css("right", elemPosition + "px");


            } else if (viewWidth < 797) {

            }
        }
    }
    // blog page
};

$(window).on("load ready resize scroll orientationchange", function () {

    if ($("form[name=checkout]").length < 1) {
      $("#checkout-only-totals").hide();
    }

         getAllTheScreenInfo();

});
